function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7,
  fill: "#FF757B"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.084 4.74l-.823-.823-3.26 3.26-3.262-3.26-.822.822L7.177 8l-3.26 3.26.822.823L8 8.823l3.261 3.26.823-.822L8.823 8l3.26-3.262z",
  fill: "#fff"
});

function SvgErrorCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgErrorCircle;